import styled, { css } from 'styled-components';

export const TestimonialContainer = styled.div`
  max-width: 1276px;
  margin: 0 auto;
`;

export const HeadingContainer = styled.div`
  text-wrap: balance;
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;
